export const TrafficCone = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 29H28" stroke="currentColor" stroke-width="2"/>
<path d="M24 29L18.1789 3.77514C18.0742 3.32141 17.6701 3 17.2045 3H14.7955C14.3299 3 13.9258 3.32141 13.8211 3.77514L8 29" stroke="currentColor" stroke-width="2"/>
<path d="M12 11H20" stroke="currentColor" stroke-width="2"/>
<path d="M11 17H21" stroke="currentColor" stroke-width="2"/>
<path d="M9 23H23" stroke="currentColor" stroke-width="2"/>
</svg>`;
